import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormItem, FormLabel } from './ui/form';
import { Switch } from './ui/switch';

interface FormFieldSwitchProps {
  name: string;
  defaultValue?: boolean;
  label?: string;
  rules?: object;
  onChange?: (checked: boolean) => void;
  onClick?: (e: React.FormEvent<HTMLButtonElement>) => void;
  required?: boolean;
  className?: string;
}

export const FormFieldSwitch: React.FC<FormFieldSwitchProps> = ({
  name,
  label,
  rules,
  defaultValue,
  onChange,
  onClick,
  required,
  className,
}) => {
  const { control } = useFormContext();
  return (
    <FormItem className="flex flex-col gap-1.5">
      {label && (
        <FormLabel className="p-[2px]">
          {label}
          {required && <span className="text-error align-top">*</span>}
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <>
            <Switch
              checked={field.value as boolean}
              onCheckedChange={(e) => {
                field.onChange(e);
                onChange && onChange(e);
              }}
              onClick={(e) => {
                onClick && onClick(e);
              }}
              defaultChecked={defaultValue}
              className={className}
            />
            {fieldState.error && <p className="text-error text-xs">{fieldState.error.message}</p>}
          </>
        )}
      />
    </FormItem>
  );
};
